import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { AppAuthReducer } from '../features/AppAuthSlice';
import {AppStateReducer, AppStateType} from "../features/AppStateSlice";
import {AppDataReducer} from "../features/AppDataSlice";

export const store = configureStore({
  reducer: {
    auth: AppAuthReducer,
    app: AppStateReducer,
    data: AppDataReducer,
  },
  middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: false,
      }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
